export default __webpack_public_path__ + "static/dashkit-alt-ceabb996193836663c8e583e5e801a0e.jpg";